<div
  [style]="mode() !== 'card' ? tileStyle() : cardFontFamily()"
  class="selectable-tile relative {{ mode() }}"
  [class.readonly]="isReadOnly()"
>
  @switch (mode()) {
    @case ('image') {
      <div
        class="tile-content"
        [class.align-left]="labelPosition() === 'left'"
        [class.align-top]="labelPosition() === 'top'"
        [class.align-bottom]="labelPosition() === 'bottom'"
        [class.align-right]="labelPosition() === 'right'"
      >
        @if (showImage()) {
          @if (!imageSrc()) {
            <div
              class="bg-primary-90 pt-8 text-primary flex items-center justify-center"
              [style]="imagePlaceholderStyles()"
            >
              <mat-icon svgIcon="icon_image_placeholder_rounded_40" class="icon" />
            </div>
          } @else {
            <img imgError [src]="imageSrc()" [style]="imageStyles()" [alt]="label()" />
          }
        }

        <span class="radio-label"> {{ label() }} </span>
      </div>
    }
    @case ('box') {
      @if (showCheckmark() && labelPosition() === 'right') {
        <div class="check-mark-spacer check-mark-spacer-square"></div>
      }
      <div
        class="tile-content"
        [style]="boxTileContentStyles()"
        [class.align-left]="labelPosition() === 'left'"
        [class.align-top]="labelPosition() === 'top'"
        [class.align-bottom]="labelPosition() === 'bottom'"
        [class.align-right]="labelPosition() === 'right'"
      >
        @if (showIcon()) {
          <div
            [style]="{
              width: iconSize(),
              height: iconSize(),
            }"
          >
            @if (icon(); as icon) {
              <mat-icon
                [style]="{ '--icon-size': iconSize() }"
                [svgIcon]="icon"
                class="accent-icon icon {{ mainIconBehavior() }}"
              />
            }
          </div>
        }

        @if (subLabel()) {
          <div class="box-label-block flex flex-col">
            <span class="radio-label"> {{ label() }} </span>
            <span class="box-sub-label" [style]="subLabelStyles()">{{ subLabel() }}</span>
          </div>
        } @else {
          <span class="radio-label"> {{ label() }} </span>
        }
      </div>

      @if (showCheckmark() && labelPosition() !== 'right') {
        <div class="check-mark-spacer"></div>
      }
      @if (showCheckmark()) {
        <mat-icon
          style="
            --icon-size: var(--checkmark-size, 24px);
            --color: var(--radio-accent, var(--bat-accent_a10));
          "
          svgIcon="icon_check_16"
          class="check-mark invisible accent-icon icon {{ checkIconBehavior() }}"
        />
      }
    }
    @case ('chip') {
      <div class="title-content">
        <span class="radio-label">{{ label() }}</span>
      </div>
    }
    @case ('card') {
      <div class="flex flex-col gap-16">
        @if (showImage() || showCheckmark()) {
          <div
            class="flex justify-between gap-32"
            [class.flex-row-reverse]="labelPosition() === 'left'"
          >
            @if (showImage()) {
              @if (!imageSrc()) {
                <div
                  class="bg-primary-90 pt-8 text-primary flex items-center justify-center"
                  [style]="imagePlaceholderStyles()"
                >
                  <mat-icon svgIcon="icon_image_placeholder_rounded_40" class="icon" />
                </div>
              } @else {
                <img imgError [src]="imageSrc()" [style]="imageStyles()" [alt]="label()" />
              }
            }

            @if (showCheckmark() && selected()) {
              <div class="card-check-mark flex items-center justify-center rounded-full">
                <mat-icon
                  style="
                    --icon-size: var(--checkmark-size, 16px);
                    --color: var(--radio-accent, var(--bat-accent_a10));
                  "
                  svgIcon="icon_check_16"
                  class="check-mark"
                />
              </div>
            } @else if (showCheckmark() && !selected()) {
              <div class="unchecked-card-check-mark flex items-center justify-center rounded-full">
                <mat-icon
                  style="--icon-size: var(--checkmark-size, 16px); --color: var(--primary-50)"
                  svgIcon="icon_check_16"
                  class="check-mark"
                />
              </div>
            }
          </div>
        }

        <div class="flex flex-col">
          <div [style]="cardHeadingStyles()" class="card-heading radio-label">{{ label() }}</div>
          @if (cardContent()?.subheading) {
            <div [style]="subheadingStyles()" class="card-subheading">
              {{ cardContent()?.subheading }}
            </div>
          }
          @if (cardContent()?.description) {
            <div [style]="descriptionStyles()" class="card-description">
              {{ cardContent()?.description }}
            </div>
          }
          @if (cardContent()?.customFields && cardContent()!.customFields!.length > 0) {
            <div
              [style]="customFieldsSectionStyles()"
              class="flex flex-col gap-8 font-normal decoration-none weight-normal card-custom-field"
            >
              @for (field of cardContent()!.customFields!; track $index; let index = $index) {
                <div
                  class="flex gap-8"
                  [class.flex-col]="field.labelBehavior === 'top'"
                  [class.items-center]="field.labelBehavior === 'left'"
                  [style.alignItems]="
                    field.labelBehavior === 'top' ? customFieldsFlexAlign() : null
                  "
                  [style.justifyContent]="
                    field.labelBehavior !== 'top' ? customFieldsFlexAlign() : null
                  "
                >
                  @if (field.labelBehavior !== 'none') {
                    <span class="font-medium" [style]="customFieldStyles()">{{ field.label }}</span>
                  }
                  <span [style]="customFieldStyles()">
                    <ng-container
                      [ngTemplateOutlet]="cellsMap()[field.format || 'text']"
                      [ngTemplateOutletContext]="{ $implicit: field.value, field, index }"
                    />
                  </span>
                </div>
              }
            </div>
          }
        </div>
      </div>
    }
  }
</div>

<!-- #region cells-->

<!-- cell: text -->
<ng-template #textCellTpl let-item let-field="field">
  {{ item | dataRowFieldValuePipe: field.columnName | formatValue: 'text' }}
</ng-template>

<!-- cell: currency -->
<ng-template #currencyCellTpl let-item let-field="field">
  {{
    item
      | dataRowFieldValuePipe: field.columnName
      | formatValue: 'currency' : { precision: field.precision, currency: field.currency }
  }}
</ng-template>

<!-- cell: number -->
<ng-template #numberCellTpl let-item let-field="field">
  {{
    item
      | dataRowFieldValuePipe: field.columnName
      | formatValue: 'number' : { precision: field.precision }
  }}
</ng-template>

<!-- cell: date -->
<ng-template #dateCellTpl let-item let-field="field">
  {{
    item
      | dataRowFieldValuePipe: field.columnName
      | formatValue: 'date' : { dateFormat: field.dateFormat }
  }}
</ng-template>

<!-- cell: datetime -->
<ng-template #datetimeCellTpl let-item let-field="field">
  {{
    item
      | dataRowFieldValuePipe: field.columnName
      | formatValue: 'datetime' : { dateTimeFormat: field.dateTimeFormat }
  }}
</ng-template>

<!-- cell: time -->
<ng-template #timeCellTpl let-item let-field="field">
  {{ item | dataRowFieldValuePipe: field.columnName | formatValue: 'time' }}
</ng-template>

<!-- cell: duration -->
<ng-template #durationCellTpl let-item let-field="field">
  {{
    item
      | dataRowFieldValuePipe: field.columnName
      | formatValue: 'duration' : { durationFormat: field.duration || 'h:mm' }
  }}
</ng-template>

<!-- cell: checkbox -->
<ng-template #checkboxCellTpl let-item let-field="field">
  @let isChecked = item | dataRowFieldValuePipe: field.columnName | formatValue: 'checkbox';
  <mat-icon
    class="col-boolean"
    [class.checked]="isChecked"
    svgIcon="{{ isChecked ? 'icon_boolean_on_24' : 'icon_boolean_off_24' }}"
  />
</ng-template>

<!-- cell: image -->
<ng-template #imageCellTpl let-item let-field="field">
  @if (item | dataRowFieldValuePipe: field.columnName; as value) {
    <img
      [src]="value"
      alt=""
      imgError="assets/images/icon-image-32.svg"
      class="col-img"
      loading="lazy"
    />
  }
</ng-template>

<!-- cell: percentage -->
<ng-template #percentageCellTpl let-item let-field="field">
  {{
    item
      | dataRowFieldValuePipe: field.columnName
      | formatValue: 'percentage' : { precision: field.precision }
  }}
</ng-template>

<!-- cell: heading -->
<ng-template #headingCellTpl let-item let-field="field">
  {{ item | dataRowFieldValuePipe: field.columnName | formatValue: 'text' }}
</ng-template>

<!-- cell: paragraph -->
<!-- Keep this in one line! -->
<ng-template #paragraphCellTpl let-item let-field="field"
  >{{ item | dataRowFieldValuePipe: field.columnName | formatValue: 'text' }}
</ng-template>

<!-- cell: richText -->
<ng-template #richTextCellTpl let-item let-field="field">
  <span
    [innerHTML]="(item | dataRowFieldValuePipe: field.columnName) ?? '' | securityTrust: 'html'"
  ></span>
</ng-template>

<!-- cell: markdown -->
<ng-template #markdownCellTpl let-item let-field="field">
  <span [innerHTML]="(item | dataRowFieldValuePipe: field.columnName) ?? '' | markdown"></span>
</ng-template>

<!-- cell: email -->
<ng-template #emailCellTpl let-item let-field="field">
  <span (click)="columnTypeClicked('email', item?.[field.columnName])">{{
    item | dataRowFieldValuePipe: field.columnName
  }}</span>
</ng-template>

<!-- cell: url -->
<ng-template #urlCellTpl let-item let-field="field">
  <span (click)="columnTypeClicked('url', item?.[field.columnName])">{{
    item | dataRowFieldValuePipe: field.columnName
  }}</span>
</ng-template>

<!-- cell: phoneNumber -->
<ng-template #phoneNumberCellTpl let-item let-field="field">
  {{ item | dataRowFieldValuePipe: field.columnName | formatValue: 'phoneNumber' }}
</ng-template>

<!-- cell: timezone -->
<ng-template #timezoneCellTpl let-item let-field="field">
  {{ item | dataRowFieldValuePipe: field.columnName | formatValue: 'text' }}
</ng-template>

<!-- cell: zipcode -->
<ng-template #zipcodeCellTpl let-item let-field="field">
  {{ item | dataRowFieldValuePipe: field.columnName | formatValue: 'text' }}
</ng-template>

<!-- cell: geopoint -->
<ng-template #geopointCellTpl let-item let-field="field">
  {{ item | dataRowFieldValuePipe: field.columnName | formatValue: 'geopoint' }}
</ng-template>

<!-- cell: secureText -->
<ng-template #secureTextCellTpl let-item let-field="field">
  {{ item | dataRowFieldValuePipe: field.columnName | formatValue: 'secureText' }}
</ng-template>
